import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferralFromLocation } from "../lib/referral";
import api from "../lib/api";

// Invisible component. Runs on every route change and captures a `?ref=SLUG`
// query param into localStorage (30-day first-touch attribution) AND asks the
// server to set a 30-day HttpOnly cookie — script storage is capped to 7 days
// by Safari, server-set cookies are not.
export default function ReferralCapture() {
  const location = useLocation();
  useEffect(() => {
    captureReferralFromLocation();
    const raw = new URLSearchParams(location.search).get("ref");
    if (raw) api.post("/referral/capture", { slug: raw.trim() }).catch(() => {});
  }, [location.pathname, location.search]);
  return null;
}
